// extracted by mini-css-extract-plugin
export var filterIncDec = "_dj-0";
export var leftBorder = "_dj-1";
export var rightBorder = "_dj-2";
export var stringInput = "_dj-3";